import React, { useState } from "react";
import styles from "./Contact.module.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { Helmet } from "react-helmet";

const Contact = () => {

  // ✅ STATE
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  // ✅ HANDLE INPUT CHANGE
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // ✅ HANDLE FORM SUBMIT
 const handleSubmit = (e) => {
  e.preventDefault();

  const phoneNumber = "919650817621"; // 👈 apna number daalo (without +)

  const message = `New Contact Form Message:

Name: ${formData.name}
Email: ${formData.email}
Subject: ${formData.subject}
Message: ${formData.message}`;

  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  window.open(whatsappURL, "_blank");

  // clear form
  setFormData({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
};
  

 
  return (
    <>
    <div>
      <Helmet>
        <title>Contact Us - Saraswati Vidya Mandir</title>
        <meta name="description" content="Get in touch with Saraswati Vidya Mandir for admissions, queries, and more. We are here to help you with all your educational needs." />
      </Helmet>
      {/* 🔥 HERO */}
      <section className={styles.hero}>
        <div className={styles.overlay}></div>

        <div className={styles.heroContent}>
          <h1>Contact Us</h1>
          <p>We are here to help you. Reach out for admissions & queries.</p>

          <button
            className={styles.heroBtn}
            onClick={() =>
              document
                .getElementById("contactForm")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Get in Touch
          </button>
        </div>
      </section>

      {/* 📌 INFO CARDS */}
      <section className={styles.infoSection}>
        <div className={styles.card}>
          <FaMapMarkerAlt className={styles.icon} />
          <h3>Address</h3>
          <p>Gali Number 3, Village Chhalera & Sadarpur, Chhalera Bangar, Sector 44, Noida, Uttar Pradesh 201303</p>
        </div>

        <div className={styles.card}>
          <FaPhoneAlt className={styles.icon} />
          <h3>Phone</h3>
          <p>+91 9650817621</p>
        </div>

        <div className={styles.card}>
          <FaEnvelope className={styles.icon} />
          <h3>Email & Social</h3>
          <p>info@svmschool.com</p>

          <div className={styles.social}>
            <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer"><FaYoutube /></a>
          </div>
        </div>
      </section>

      {/* 📍 MAP + FORM */}
      <section className={styles.contactSection} id="contactForm">

        {/* 🗺️ MAP */}
        <div className={styles.map}>
     
        
<iframe
  title="school-map"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.4867541999465!2d77.33837867549789!3d28.555142775707065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce596e9abd4d1%3A0x1db303960d4286fd!2sSaraswati%20Vidya%20Mandir%20School%20-%20Chhalera!5e0!3m2!1sen!2sin!4v1776927348699!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>
          
         
        </div>

        {/* 📩 FORM */}
        <div className={styles.formContainer}>
          <h2>Send Message</h2>

          <form className={styles.form} onSubmit={handleSubmit}>

            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
            />

            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              required
            />

            <input
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Subject"
            />

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              rows="5"
            ></textarea>

            <button type="submit">Send Message</button>

          </form>
        </div>

      </section>

    </div>
    </>
  );
};

export default Contact;